export default __webpack_public_path__ + "static/media/flare.2e8e2db6.png";